import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PanelHeader from '../../components/handoff/PanelHeader';
import * as specSelectors from '../../selectors/handoff';
import * as elementUtils from '../../utils/handoff/element';
import onlyIf from '../../hocs/onlyIf';
import { hideHandoff } from '../../actionCreators';
function mapStateToProps(state) {
    var element = specSelectors.getSelectedElement(state);
    if (!element) {
        return {};
    }
    return {
        isDownloadable: elementUtils.hasAssets(element),
        layerName: elementUtils.getLayerName(element),
        layerType: specSelectors.getSelectedElementType(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onClose: function () {
            dispatch(hideHandoff());
        },
    };
}
export default compose(connect(mapStateToProps, mapDispatchToProps), onlyIf(function (props) { return props.layerType; }))(PanelHeader);
